<div class="location-map-shell">
    <div #mapContainer class="location-map notranslate" role="region" aria-label="Kaart met locaties"></div>

    <div class="location-count" aria-live="polite">
        <i class="bi bi-geo-alt" aria-hidden="true"></i>
        <span #locationCountText>{{ locationCountLabel }} {{ locationCountUnit }}</span>
    </div>

    <button type="button"
            class="map-reset-control"
            [title]="resetMapLabel"
            [attr.aria-label]="resetMapLabel"
            (click)="resetMapView()">
        <i class="bi bi-bullseye" aria-hidden="true"></i>
    </button>
</div>
